import classNames from "classnames";
import OverflowLabel from "./OverflowLabel";

type DasboardWidgetTitleProps = {
    title: string;
    icon?: string;
};

export function DasboardWidgetTitle(props: DasboardWidgetTitleProps){
    return (
        <h4 className="dasboard-widget-title d-inline-flex align-items-center mb-0 gap-1">{props.icon && (<i className={classNames(props.icon, "widget-icon")}></i>)} <OverflowLabel isVisible={true} text={props.title} /> </h4>
    ); 
}